import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      height: '100%',
      minHeight: 245,
    },
    content: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    amount: {
      paddingTop: theme.spacing(0.5),
      [theme.breakpoints.down('md')]: {
        paddingBottom: theme.spacing(3),
      },
      [theme.breakpoints.up('md')]: {
        paddingBottom: theme.spacing(5),
      },
    },
    availableCashAmount: {
      paddingTop: theme.spacing(0.5),
      [theme.breakpoints.down('md')]: {
        paddingBottom: theme.spacing(1),
      },
      [theme.breakpoints.up('md')]: {
        paddingBottom: theme.spacing(2),
      },
    },
    infoItem: {
      [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(2),
      },
    },
    tooltipIcon: {
      verticalAlign: 'text-bottom',
      height: 17,
      color: theme.palette.grey[300],
    },
    tooltip: {
      background: theme.palette.grey[800],
      lineHeight: '36px',
    },
    tooltipArrow: {
      color: theme.palette.grey[800],
    },
    tooltipTypography: {
      textAlign: 'center',
      color: theme.palette.grey[100],
      paddingTop: 5,
    },
  })
);
